module.exports = __webpack_public_path__ + "media/images/galata_680x1150-2ea788734e3a4b91ac8597418d287c87.jpg";